<template>
  <div class="chart-wrapper">
    <!-- Chart comes here -->
    <slot></slot>

    <!-- Custom Legend -->
    <div class="flexRowWrap flexRowJustifyCenter marginT-32" v-if="labels">
      <div 
        v-for="(label, index) in labels" 
        :key="index" 
        class='flexRowAlignCenter padding-5-12'
      >
        <div 
          :style="{ backgroundColor: label.color ? label.color : colors[index], width: '24px', height: '24px', borderRadius: '50%', marginRight: '8px' }"
        ></div>
        <h6 class='lineHeight-100 marginB0'>{{ label.name ? label.name : label }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['type', 'apiData', 'valueField', 'demographicName', 'colorValues'],
    data () {
        return {
            labels: [],
            // datasets: [],
            LIMIT: 15,
            maxAge: 0,
            ageIndices: {},
            maxAgeLabels: [],
            colors: [
                '#1957CD',
                '#0F347B',
                '#46ADE3',
                '#1895A7',
                '#A5E3ED',
                '#44CEA5',
                '#297C63',
                '#AEE0C6',
                '#532C95',
                '#9E9BF0',
                '#6F0C4E',
                '#B2127C',
                '#E1AFEF',
                '#EC3240',
                '#262F35',
                '#A8ACAE',
                '#1957CD',
                '#0F347B',
                '#46ADE3',
                '#1895A7',
                '#A5E3ED',
                '#44CEA5',
                '#297C63',
                '#AEE0C6',
                '#532C95',
                '#9E9BF0',
                '#6F0C4E',
                '#B2127C',
                '#E1AFEF',
                '#EC3240',
                '#262F35',
                '#A8ACAE'
            ]
        }
    },
    methods: {
        getLabels () {
            if (this.type === 'pie') {
                const apiLabels = this._.map(this.apiData, 'demographic')
                let labels = []

                _.forEach(apiLabels, (l, id) => {
                    if (l === '' || l === null) {
                        labels.push('Not Specified')
                    } else {
                        labels.push(l)
                    }
                })
                console.log('hey', labels)
                // If grouped by age, display data by age groups
                if (this.groupedBy === 'b_birthdate' &&
                    labels.length > this.LIMIT) {
                    // Save the order of ages
                    this.ageIndices = {}
                    const ages = labels.filter((label, id) => {
                    this.ageIndices[id] = !isNaN(parseInt(label)) ? parseInt(label) : 'Unknown'
                    return label !== 'Unknown'
                    }).map(label => parseInt(label))
                    // Sort ages
                    ages.sort((a, b) => a - b)

                    // Reset labels to group ages by 5
                    labels = labels.includes('Unknown') ? ['Unknown'] : []
                    let i = 0
                    this.maxAge = ages[ages.length - 1]
                    this.maxAgeLabels = []
                    while (i <= this.maxAge) {
                    labels.push(`${i} - ${i + 5}`)
                    this.maxAgeLabels.push(i + 5)
                    i += 6
                    }
                }
                this.labels = labels
            } else {
                // stacked-line
                let labels = []
                Object.values(this.apiData).forEach((value) => {
                    value.forEach((item, index) => {
                        if (item.demographic) {
                            if (labels.filter(e => e.name === item.demographic).length === 0) {
                            let color = this.colors[labels.length - 1]

                            if (this.colorValues) {
                                let colorValue = this.colorValues.find(obj => obj.value === this.demographicName)
                                if (colorValue) {
                                let colorData = colorValue.colors.find(obj => obj.name === item.demographic)
                                color = colorData ? colorData.color : color
                                }
                            }

                            labels.push({ name: item.demographic, color: color })
                            }
                        }
                    })
                })
                this.labels = labels
            }
        }
    },
    watch: {
        apiData: function () {
            this.getLabels()
            // if (this.type === 'stacked-line') {
            // // console.log(this.apiData)
            // }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/ChartLegendWrap.vue